import { Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

import { CerFormView } from '@form/cer-form-view';
import { UiCommand, UiCommandEvent } from '@ui/cer-ui-types';

import { CerFormToolbar } from '@cer/cer-form/cer-form-toolbar';
import { uiCmdComponentMaximize, uiCmdDocumentZoomIn, uiCmdDocumentZoomOut } from '@cer/cer-ui/cer-ui-commands';
import { CerViewDocumentGenericType, documentGenericTypeByExtension, documentToolbarItemsStateGet, documentTypeByExtension, fileNameExtensionGet, plainUrl } from './cer-form-view-document-type';
import { CerToolbarItemState } from '@cer/cer-toolbar/cer-toolbar-command-adapter';

@Component({
  selector: 'cer-form-view-type-document-generic',
  template: `
    <div *ngIf="hasToolbar" class="cer-flex-static cer-overflow-hidden" #toolbarDiv></div>
    <div class="cer-flex cer-flex-main cer-overflow-auto">
        <div [ngSwitch]="genericType" [style]="zoomStyle" class="cer-flex cer-flex-main cer-overflow-hidden">
          <div *ngSwitchCase="'div'" class="cer-flex cer-flex-main cer-overflow-hidden" [innerHtml]="document | safe"></div>
          <img *ngSwitchCase="'img'" class="cer-flex cer-flex-main cer-overflow-hidden" [src]="documentUrlPlain | safe" />
          <iframe *ngSwitchCase="'iframe'" class="cer-flex cer-flex-main cer-overflow-hidden cer-no-border" [src]="documentUrl | safe"></iframe>
          <div *ngSwitchCase="null" class="cer-flex cer-flex-main cer-overflow-hidden"><div class="cer-flex cer-flex-main cer-flex-center">Ingen visning</div></div>
        </div>
    </div>`
})

export class CerFormViewTypeDocumentGenericComponent implements OnDestroy {

  private toolbarBuildIn: UiCommand[] = [uiCmdDocumentZoomIn, uiCmdDocumentZoomOut];

  ngOnDestroy(): void {
    this.toolbar?.destroy();
  }

  protected genericType: CerViewDocumentGenericType;
  protected documentUrlPlain: string;
  
  private _view: CerFormView;
  get view(): CerFormView { return this._view; };
  @Input() set view(view: CerFormView) {
    if (view && this._view != view) {
      this._view = view;
      this.documentUrl = view?.documentUrl;
      view.commandSubscribe((e) => this.onCommand(e));
    }
  }

  protected document!: string;
  
  private _documentUrl!: string;
  get documentUrl(): string { return this._documentUrl };
  @Input() set documentUrl(documentUrl: string) {
    if (documentUrl != this._documentUrl) {
      const ext = fileNameExtensionGet(this.view?.documentFileName);
      const documentType = documentTypeByExtension(ext);
      if (documentType == 'generic') {
        if ( documentGenericTypeByExtension(ext) == 'div') {
          console.log(this.view?.documentFileName);
        }
        this.genericType = documentGenericTypeByExtension(ext);
        this._documentUrl = documentUrl;
        this.documentUrlPlain = plainUrl(this.documentUrl);
        this.toolbarUpdate();
      }
    }
  }

  public onCommand(e: UiCommandEvent) {
    switch (e.commandId) {
      case uiCmdComponentMaximize.id:
        this.zoom = 1.00;
        setTimeout(() => this.updateSize(this.zoom));
        this.toolbarUpdate();
        break;
      case uiCmdDocumentZoomIn.id:
        this.zoomIn();
        this.toolbarUpdate();
        break;
      case uiCmdDocumentZoomOut.id:
        this.zoomOut();
        this.toolbarUpdate();
        break;
    }
  }

  // #region Toolbar
  protected hasToolbar: boolean = true;
  private toolbar: CerFormToolbar;
  @ViewChild('toolbarDiv') set toolbarDivRefSet(ele: ElementRef<HTMLDivElement>) {
    this.initToolbar(ele?.nativeElement);
  }

  initToolbar(divParent: HTMLDivElement) {
    if (divParent != null && this.toolbar == null) {
      this.toolbar = new CerFormToolbar(divParent, this._view, this.toolbarBuildIn, this.toolbarItemStatesGet.bind(this));
      this.hasToolbar = this.toolbar != null;
    }
  }

  private toolbarItemStatesGet(): Map<string, CerToolbarItemState> {
    const zoomIn = this.genericType != null;
    const zoomOut = zoomIn && this.zoom > 1;
    return documentToolbarItemsStateGet(zoomIn, zoomOut, this.documentUrl,  this.view?.documentOriginalUrl, this.view?.documentOriginalFileName)
  }

  private toolbarUpdate() {
    this.toolbar?.itemStateApply();
  }

  // #endregion

  public zoomIn() {
    this.zoom = (this.zoom ?? 1.00) + 0.25;
    this.updateSize(this.zoom);
  }

  public zoomOut() {
    this.zoom = (this.zoom ?? 1.00) - 0.25;
    if (this.genericType != 'div') {
      if (this.zoom <= 1) {
        this.zoom = 1.00;
      }
    }
    this.updateSize(this.zoom);
  }

  private zoom: number = 1.0;
  protected zoomStyle: string = '';
  private updateSize(zoom: number) {
    this.zoomStyle = (zoom == 1.0)
      ? ''
      : 'transform: scale(' + this.zoom + '); transform-origin: 0% 0%;';
  }

}